import GrowingTeam from "@/components/landing/common/GrowingTeam";
import Banner from "@/components/landing/ourTeam/Banner";
import TeamMember from "@/components/landing/ourTeam/TeamMember";

export default function OurTeam() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Team Member section */}
      <TeamMember />

      {/* Growing Team section */}
      <GrowingTeam />
    </>
  );
}
